var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocationIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 62,
    viewBox: "0 0 48 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_3114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5594 56C22.9446 55.588 22.5348 55.176 22.3299 54.764C17.4118 47.7602 12.2888 40.5504 7.3708 33.5466C5.52653 30.8687 4.29702 27.5728 4.0921 24.2768C3.27243 15.6251 7.98555 7.38529 15.7725 3.88338C23.3545 0.587466 30.5266 1.61744 36.8791 6.9733C40.7725 10.2692 43.2316 14.8011 43.8463 19.951C44.4611 24.8948 43.2316 30.0447 40.1578 34.1646C35.2397 40.9624 30.5266 47.7602 25.6086 54.764C25.1987 55.382 24.7889 55.794 24.1741 56H23.5594Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_3114",
    x: 0,
    y: 0,
    width: 48,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_3114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_3114",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocationIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location_icon.8febc82e0b9c451fb862e38db1e8f498.svg";